// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentsListColumns-EmptyResultTypography_cls1__6MwKH","cls2":"PaymentsListColumns-EmptyResultTypography_cls2__s0EZV PaymentsListColumns-EmptyResultTypography_cls1__6MwKH"};